import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductCard from '../components/ProductCard';
import { Heart } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Wishlist = ({ setCurrentAudio }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchWishlist();
    }, []);

    const fetchWishlist = async () => {
        try {
            const response = await axios.get(`${API}/wishlist`);
            setProducts(response.data.products);
        } catch (error) {
            console.error('Error fetching wishlist:', error);
            toast.error('Failed to load wishlist');
        } finally {
            setLoading(false);
        }
    };

    const handleAddToCart = async (productId) => {
        try {
            await axios.post(`${API}/cart`, { product_id: productId });
            toast.success('Added to cart!');
        } catch (error) {
            toast.error('Failed to add to cart');
        }
    };

    const handleRemoveFromWishlist = async (productId) => {
        try {
            await axios.delete(`${API}/wishlist/${productId}`);
            toast.success('Removed from wishlist');
            fetchWishlist();
        } catch (error) {
            toast.error('Failed to remove from wishlist');
        }
    };

    const handlePlayAudio = (product) => {
        setCurrentAudio({
            url: product.audio_url,
            name: product.name
        });
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center pt-16">
                <div className="text-xl text-muted-foreground">Loading...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen pt-24 px-6 md:px-12 lg:px-24 py-12" data-testid="wishlist-page">
            <h1 className="text-5xl md:text-7xl font-bold tracking-tighter mb-12">My Wishlist</h1>

            {products.length === 0 ? (
                <div className="text-center py-24" data-testid="empty-wishlist">
                    <Heart className="w-16 h-16 mx-auto mb-4 text-muted-foreground" strokeWidth={1.5} />
                    <p className="text-xl text-muted-foreground mb-6">Your wishlist is empty</p>
                    <button 
                        onClick={() => window.location.href = '/browse'}
                        className="btn-primary"
                        data-testid="browse-products-button"
                    >
                        Browse Products
                    </button>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8" data-testid="wishlist-products">
                    {products.map((product) => (
                        <ProductCard 
                            key={product.id}
                            product={product}
                            onAddToCart={handleAddToCart}
                            onAddToWishlist={handleRemoveFromWishlist}
                            onPlayAudio={handlePlayAudio}
                            isInWishlist={true}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default Wishlist;
